import "symbol-observable"; // Ensure Redux and DevTools share the same Symbol.observable reference
import { type AnyAction, combineReducers } from "redux";

import { reducer as currentAccount } from "./accounts/accountSlice";
import { reducer as documents } from "./documents";
import estates from "./estate";
import postings from "./postings";
import { reducer as propertyManagement } from "./propertyManagement/propertyManagementSlice";
import { reducer as sessionToken } from "./session/sessionActions";
import tickets from "./ticket";
import { reducer as uiState } from "./uiState";
import { reducer as currentUser } from "./user/userActions";

const appReducer = combineReducers({
  currentAccount,
  currentUser,
  estates,
  postings,
  propertyManagement,
  sessionToken,
  tickets,
  uiState,
  documents,
});

type RootState = ReturnType<typeof appReducer>;

// clear all data on logout
const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === "currentUser/clearUser") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
